import { useState } from "react";
import { LoadingCircle } from "../common";
import { useLocation } from "react-router-dom";

const MortgageIframeView = () => {
	const [isLoading, setIsLoading] = useState(true);
	const location = useLocation();
	const from = (
		location.state as {
			from?: string;
		}
	)?.from;
	const baseMortgageUrl = "https://mortgages1.zown.ca";

	return (
		<div className="relative h-full w-full">
			{isLoading && (
				<div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-75 z-10">
					<LoadingCircle />
				</div>
			)}

			<iframe
				title="Mortgage Iframe"
				src={
					from === "savings-view"
						? `${baseMortgageUrl}/employment-details`
						: baseMortgageUrl
				}
				className="h-full w-full"
				onLoad={() => setIsLoading(false)}
			/>
		</div>
	);
};

export { MortgageIframeView };
